<!--suppress ALL -->
<template>
  <g-field v-if="!skipLabel" :label="label" :type="type" :message="message">
    <g-field is-grouped>
      <g-select @change="onSelected" @input="onSelected" is-fullwidth :value="guruId || ''"
                :placeholder="isLoading ? $t('text.loading') : (guruPengajians.length === 0 ? $t('text.no_content_loaded') : placeholder)"
                class="control is-expanded"
                :disabled="isLoading">
        <option value="">{{ placeholder }}</option>
        <option v-for="guru in guruPengajians"
                :value="guru.id" :key="guru.id">
          {{ guru.profile || guru.username }}
        </option>
      </g-select>
      <div v-if="isLoading" class="control">
        <g-button type="light">
          <span class="icon">
            <i class="fas fa-spinner fa-spin"></i>
          </span>
        </g-button>
      </div>
    </g-field>
  </g-field>
  <div v-else>
    <g-field is-grouped>
      <g-select @change="onSelected" @input="onSelected" is-fullwidth :value="guruId || ''"
                :placeholder="isLoading ? $t('text.loading') : (guruPengajians.length === 0 ? $t('text.no_content_loaded') : placeholder)"
                class="control is-expanded"
                :disabled="isLoading">
        <option value="">{{ placeholder }}</option>
        <option v-for="guru in guruPengajians"
                :value="guru.id" :key="guru.id">
          {{ guru.profile || guru.username }}
        </option>
      </g-select>
      <div v-if="isLoading" class="control">
        <g-button type="light">
          <span class="icon">
            <i class="fas fa-spinner fa-spin"></i>
          </span>
        </g-button>
      </div>
    </g-field>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Container } from 'annotation';
import {cloneDeep} from 'lodash';
import GuruPengajian from "../../../entity/GuruPengajian";
import PresensiKegiatanService from "../../../service/PresensiKegiatanService";
import Response from "../../../service/Response";

@Component
export default class GuruPengajianSelect extends Vue {

  public get presensiKegiatanService(): PresensiKegiatanService {
    return Container.get(PresensiKegiatanService);
  }

  @Prop({default: "", type: String})
  public guruId: string;

  @Prop({default: false, type: Boolean})
  public skipLabel: boolean;

  @Prop({default: "Guru Pengajar", type: String})
  public label: string;

  @Prop({default: "Pilih Guru Pengajar", type: String})
  public placeholder: string;

  @Prop({type: String, default: null})
  public type: any;

  @Prop({type: String, default: null})
  public message: any;

  public guruPengajians: Array<GuruPengajian> = [];
  public isLoading: boolean = false;

  public async mounted() {
    await this.doFind();
  }

  public async doFind() {
    this.isLoading = true;

    const response: Response = await this.presensiKegiatanService.findGuruPengajian();

    if (response.isSuccess) {
      // Handle nested pagination structure: {status, message, data: {data: [...], total_rows, ...}}
      const responseData = response.getData();
      
      if (responseData && responseData.data && Array.isArray(responseData.data)) {
        // Deserialize the nested data array
        const nestedResponse = new Response({
          data: responseData.data,
          status: response.statusResponse,
          serializer: GuruPengajian
        });
        this.guruPengajians = nestedResponse.getDeserializeResponse([], GuruPengajian);
      } else {
        // Fallback to original structure if nested structure not found
        this.guruPengajians = response.getDeserializeResponse([], GuruPengajian);
      }
    }

    this.isLoading = false;
  }

  public onSelected(userId: any) {
    // Ensure userId is a string
    const userIdString = userId ? String(userId) : '';
    
    const guru: GuruPengajian = this.guruPengajians.find((item: GuruPengajian) => item.id === userIdString) ||
      new GuruPengajian();

    // Emit update to sync with parent
    this.$emit('update:guruId', userIdString);
    this.$emit('guru-selected', cloneDeep(guru));
  }
}
</script>

